import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';

function ImageCard(props) {
  return (
    <Card sx={{ maxWidth: props.maxWidth  }}>
        <CardMedia component="img" height={props.height} image={props.img} alt={props.alt} sx={{borderRadius:"-1px"}}/>
    </Card>
  );
}

export default ImageCard;